export default "__VITE_ASSET__Devu9pdv__"